import React, {useState,useEffect} from "react";
import './PC.css';
import ContainUser  from './Contain/ContainUser';


export default function PCUser(props) {
  const [ID] = useState(props.ID)
  const [CurrentIdName, setCurrentIdName] = useState("")
  const [Contain, setContain] = useState("Profile")

  useEffect(()=>{
    document.getElementById("Profile").style.visibility = "hidden";
    setCurrentIdName("Profile");
  },[])

  const click_ =(id_name)=>{
    document.getElementById(CurrentIdName).style.visibility = "visible";
    document.getElementById(id_name).style.visibility = "hidden";
    setCurrentIdName(id_name);
    setContain(id_name);
  }

  return (
    <div>
        <div className="PC-title">
          <h1>Playgrounds</h1>
        </div>

        <div className="PC-quick">

          <div className="PC-display">
          <div><h3>Profile</h3><h2>个人信息</h2> </div>
          <div><h3>Logout</h3><h2>退出</h2> </div>
          <div><h3>Puzzle</h3><h2>华容道</h2></div>
          <div><h3>Album</h3><h2>相册</h2></div>
          </div>

          <div className="PC-button">
          <div id="Profile" onClick={()=>click_("Profile")}><h3>Profile</h3><h2>个人信息</h2> </div>
          <div id="Logout" onClick={()=>click_("Logout")}><h3>Logout</h3><h2>退出</h2> </div>
          <div id="Puzzle" onClick={()=>click_("Puzzle")}><h3>Puzzle</h3><h2>华容道</h2></div>
          <div id="Album" onClick={()=>click_("Album")}><h3>Album</h3><h2>相册</h2></div>
          </div>

        </div>

        <div className="PC-contain">
          <ContainUser 
            ContainInfo = {Contain}
            ID = {ID}/>
        </div>

    </div>
  );
}

